export default "__VITE_ASSET__C7XWa_V$__"